import axios from "axios";
import router from "./router";
import Message from 'element-ui';
import store from './store';
import Cookies from 'js-cookie';

// 请求拦截  设置统一header
axios.interceptors.request.use(
	config => {
		// config.cancelToken = new axios.CancelToken(function(cancel) {
		// 	store.commit('pushToken', {
		// 		cancelToken: cancel
		// 	})
		// })
		if (Cookies.get("token"))
			config.headers.Authorization = 'JWT ' + Cookies.get("token");
		//console.log(config.headers)
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

// 响应拦截  401 token过期处理
axios.interceptors.response.use(
	response => {
		return response;
	},
	error => {
		// 错误提醒
		// Message.error(error.response.data);

		const {
			status
		} = error.response;
		if (status == 401) {
			// Message.error('token值无效，请重新登录');
			// 清除token
			// localStorage.removeItem("token");
			if (process.env.NODE_ENV === "production") {
			  Cookies.remove('token', { domain: "hzng-iot.com" });
			} else {
			  Cookies.set('token', '', -1)
			}

			// 页面跳转
			router.push("/login");
		} else if (status == 500) {
			Message.error('请求失败');
		} else {
			// consol.log(error)
			if (error.response.data) {
				if (error.response.data.msg) {
					// Message.error(error.response.data.msg);
				} else {
					Message.error(error.response.data);
				}
			} else {
				Message.error('无数据');
			}
		}

		return Promise.reject(error);
	}
);

export default axios;
